import React from 'react';
import PropTypes from 'prop-types';
import { FormFieldGroupHeader } from '@patternfly/react-core';

const StepContainer = ({ title, children, className }) => {
  return (
    <div className={className}>
      { (title && <FormFieldGroupHeader titleText={{ text: title, id: 'asset-fields' }} />) }
      { children }
    </div>);
};

StepContainer.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string
};

export default StepContainer;
